export default __webpack_public_path__ + "static/asoka-150x117-dc27cb1fbe3235008796911982456f23.png";